import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { useSiteSettings, waLink, telLink } from '../lib/SiteSettingsContext';

export default function FloatingButtons() {
    const { settings: s } = useSiteSettings();
    return (
        <div className="fixed right-3 sm:right-5 bottom-3 sm:bottom-5 z-[8000] flex flex-col gap-2.5 sm:gap-3" data-testid="floating-actions">
            <a
                href={waLink(s.contact_whatsapp)}
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_6px_24px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform"
                data-testid="floating-whatsapp"
                aria-label="WhatsApp"
            >
                <MessageCircle size={22} color="white" aria-hidden="true" />
            </a>
            <a
                href={telLink(s.contact_phone)}
                className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#1B4332] flex items-center justify-center shadow-[0_6px_24px_rgba(27,67,50,0.45)] hover:scale-110 transition-transform"
                data-testid="floating-call"
                aria-label="Call"
            >
                <Phone size={20} color="white" aria-hidden="true" />
            </a>
        </div>
    );
}
